import React from "react";
import { Row, Col, Card, Divider } from "antd";
import { OHeader } from "../text/OText";
import SpeechBubble from "../layout/SpeechBubble";

export const getSplitRatio = (short)=> (short ? 0.6 : 0.5);
export const GraphCardStyleContext = React.createContext();
/**
 * Divide unit that use to reduce legend height size.
 */
export const VerticalHeightDivider = 2;
export default ({header, onHeaderClick, singleLineHeader = true, graph, legend})=>(
	<GraphCardStyleContext.Consumer>
		{context=>{
			const { 
				style, singleLineHeader = true, height = 300, 
				legendVertHeightRatio = 0.5, legendStyle, 
				chartWidthRatio, isVertical = false,
				hilight, hilightColor,
			} = context || {};
			const graphSize = isVertical ? 24 : Math.floor(22 * chartWidthRatio);
			const legendSize = isVertical ? 24 : (22 - graphSize);
			const nextGraphElement = [];
			if(!isVertical){
				nextGraphElement.push(
					<Col key={0} style={{display:"flex", justifyContent:"center"}} 
						span={2}>
						<Divider style={{height}} type="vertical" />
					</Col>);
			}
			nextGraphElement.push(
				<Col key={1} style={{
					height: isVertical ? height * legendVertHeightRatio : height, 
					overflow:"auto",
					...legendStyle,
				}} span={legendSize}>
					{legend}
				</Col>);
			return <div style={{...style}}>
				<SpeechBubble hilight={hilight} hilightColor={hilightColor}>
					<OHeader onClick={onHeaderClick} singleLine={singleLineHeader}>{header}</OHeader>
					<Row>
						<Col style={{height}} span={legend === undefined ? 24 : graphSize}>
							{graph}
						</Col>
						{legend ? nextGraphElement : undefined}
					</Row>
				</SpeechBubble>
			</div>;
		}}
	</GraphCardStyleContext.Consumer>
);




// WEBPACK FOOTER //
// ./src/components/report/GraphCard.js